import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
// import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "UserLogin",
    component: () => import("../views/UserLogin.vue"),
  },
  {
    path: "/auth/verifyIdentity",
    name: "verifyIdentity",
    component: () => import("../views/auth/VerifyIdentity.vue"),
  },
  {
    path: "/auth/letter",
    name: "Letter",
    component: () => import("../views/auth/Letter.vue"),
  },
  {
    path: "/auth/sign",
    name: "Sign",
    component: () => import("../views/auth/Sign.vue"),
  },
  {
    path: "/auth/feedback",
    name: "Feedback",
    component: () => import("../views/auth/Feedback.vue"),
  },
  {
    path: "/contract/index",
    name: "contractIndex",
    component: () => import("../views/contract/Index.vue"),
  },
  {
    path: "/contract/detail",
    name: "contractDetail",
    component: () => import("../views/contract/Detail.vue"),
  },
  {
    path: "/contract/link",
    name: "contractLink",
    component: () => import("../views/contract/Link.vue"),
  },
  {
    path: "/company/doc",
    name: "companyDoc",
    component: () => import("../views/company/Doc.vue"),
  },
  {
    path: "/contract/signedFeedback",
    name: "contractSignedFeedback",
    component: () => import("../views/contract/SignedFeedback.vue"),
  },
  {
    path: "/company/index",
    name: "companyIndex",
    component: () => import("../views/company/Index.vue"),
  },
  {
    path: "/company/signedFeedback",
    name: "companySignedFeedback",
    component: () => import("../views/company/SignedFeedback.vue"),
  },
  { path: "/:pathMatch(.*)*", redirect: "/" }, // 处理 404 重定向到首页
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
